<template>
  <aw-color-picker 
    :alpha="alpha"
    :swatches="swatches"
    v-model="color"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    alpha: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: null
    },
    swatches: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    color: {
      get() {
        this.setBcColorCssProps(this.parseHex(this.modelValue))
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    parseHex(hex) {
      let hexArr = hex.substr(1).split('')

      let h = hexArr[0] + hexArr[1]
      let e = hexArr[2] + hexArr[3]
      let x = hexArr[4] + hexArr[5]
      let r = parseInt(h, 16)
      let g = parseInt(e, 16)
      let b = parseInt(x, 16)

      return {
        hex: '#' + h + e + x,
        r,
        g,
        b,
      }
    },
    setBcColorCssProps(colorData) {
      const root = document.documentElement
      root.style.setProperty('--primaryColorR', colorData.r)
      root.style.setProperty('--primaryColorG', colorData.g)
      root.style.setProperty('--primaryColorB', colorData.b)
      root.style.setProperty('--primaryColor', colorData.hex)
    },
  }
}
</script>

<style lang="scss" scoped></style>
